export const tabOpenByUrl = () => {
    $(document).ready(() => {
        let url = location.href.replace(/\/$/, "");

        if (location.hash) {
            window.scrollTo(0, 0);
            setTimeout(function() {
                window.scrollTo(0, 0);
            }, 1);

            const hash = url.split("#");
            const activeTabId = `${hash[1]}-tab`;
            const activeTab = document.getElementById(activeTabId);

            if (activeTab && !activeTab.classList.contains('active')) {
                const allTabPanes = document.querySelectorAll('.tab-pane');

                allTabPanes.forEach((item) => {
                    item.classList.remove('active', 'in');
                });

                $('#' + activeTabId).tab('show');
            }
        }
    });
};
